export const Experiments = {
  TrackingEvents: {
    donateButtonClick: 'donateButtonClick',
    shareModalOpen: 'shareModalOpen',
    shareSocialButtonClick: 'shareSocialButtonClick',
  },

  ConsumerFintech: {
    CheckoutConversion: {
      EmbeddedCheckoutF4: {
        flag: 'consumerfintech_jgcheckout_conversion_embedded_checkout_f4',
        excludedFlag:
          'consumerfintech_jgcheckout_conversion_embedded_checkout_f4_applepay',
      },
    },
  },

  AddSocialIconsToShareModal: {
    featureKey: 'consumerairwalk_legacyfrp_shareclick_social_icons',
    AddSocialIconsToShareModalExperiment: {
      experimentKey: 'consumerairwalk_legacyfrp_shareclick_social_icons',
      variations: {
        SocialIconsOnShareModal: 'social_icons_on_share_modal',
        defaultShareModal: 'default_share_modal',
      },
    },
  },

  InstagramShareOption: {
    featureKey: 'consumerairwalk_legacyfrp_shareclick_instagram_share',
    InstagramShareOptionExperiment: {
      experimentKey: 'consumerairwalk_legacyfrp_shareclick_instagram_share',
      variations: {
        instagramShareOption: 'instagram_share_option',
        defaultShareModal: 'default_share_modal',
      },
    },
  },
};
